var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 321.45 321.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#04a868;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u041F\u043B\u044E\u0441") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.75,224.19H276.22V100.3a11,11,0,0,0-11-11H234.87a11,11,0,0,0-11,11V224.19H100.34a11,11,0,0,0-11,11v30.34a11,11,0,0,0,11,11H223.87V399.7a11,11,0,0,0,11,11h30.35a11,11,0,0,0,11-11V276.53H399.75a11,11,0,0,0,11-11V235.19A11,11,0,0,0,399.75,224.19Z",
    transform: "translate(-89.3 -89.3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M395.7,211.45h-108V104.3a15,15,0,0,0-15-15H225.6a15,15,0,0,0-15,15V211.45H104.3a15,15,0,0,0-15,15v47.1a15,15,0,0,0,15,15H210.6V395.7a15,15,0,0,0,15,15h47.1a15,15,0,0,0,15-15V288.55h108a15,15,0,0,0,15-15v-47.1A15,15,0,0,0,395.7,211.45Z",
    transform: "translate(-89.3 -89.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.99b2fbe7e72d467634bc8e1185b6463c.svg";
export { ForwardRef as ReactComponent };